import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const ContactAccountsModelSchema = z
  .object({
    id: z.string(),
    account_id: z.string().nullish(),
    account_name: z.string().nullish(),
    contact_id: z.string().nullish(),
    relationship_category_id: z.string().nullish(),
    title: z.string().nullish(),
    current: z.boolean().nullish(),
    from_date: z.string().nullish(),
    to_date: z.string().nullish(),
    is_primary: z.boolean().nullish()
  })
  .strict()

export const ContactAccountsModelFields = makeFieldKeys(ContactAccountsModelSchema)

export type ContactAccountsModel = z.infer<typeof ContactAccountsModelSchema>

function validateContactAccountsModel(data: unknown): ContactAccountsModel {
  try {
    return validateWithZodSchema(ContactAccountsModelSchema, data, 'contact accounts model')
  } catch (error) {
    throw new Error(`Contact accounts model validation failed: ${error}`)
  }
}
